<gax-select-form-field-deprecated-use-mat-select
  [showInfoIcon]="displayCountryInfo || displaySocialTaxInfo"
  (infoIconClicked)="
    displaySocialTaxInfo
      ? showSocialTaxInformationModal()
      : showCountryInformationModal()
  "
  [label]="countryLabel"
  [formControl]="countryControl"
  (searchChanged)="onSearchCountry($event)"
  [required]="countryRequired"
>
  <gax-select-trigger>
    {{ countryControl.value | countryName: true }}
  </gax-select-trigger>
  @if (!countryRequired) {
    <gax-option
      class="text-underline font-bold color-transparent"
      [value]="null"
      (click)="clearSelection()"
      >Clear selection</gax-option
    >
  }
  @for (option of filteredCountries | async; track option) {
    <gax-option
      [value]="option.code"
      [disabled]="disabledCountries?.includes(option.code) || false"
      >{{ option.code | countryName: true }}
    </gax-option>
  }
  @if (countryControl.hasError("required")) {
    <gax-error> {{ countryLabel }} required </gax-error>
  }
  @if (this.countryControl.hasError("duplicateIncomeBandingCountry")) {
    <gax-error>
      This country has already been added to the income tax
    </gax-error>
  }
  @if (this.countryControl.hasError("duplicateSocialTaxCountry")) {
    <gax-error>
      This country has already been added to the social tax
    </gax-error>
  }
</gax-select-form-field-deprecated-use-mat-select>

@if (
  locationFormHelper.supportsRegionCalculations(countryControl.value) &&
  regionControl
) {
  <gax-select-form-field-deprecated-use-mat-select
    class="mt-15"
    [label]="regionLabel"
    [hint]="
      regionControl.invalid && regionControl.pristine
        ? regionLabel + ' required for ' + (countryControl.value | countryName)
        : ''
    "
    [formControl]="regionControl"
    [search]="true"
    (searchChanged)="onSearchRegion($event)"
    [required]="regionRequired"
  >
    <gax-select-trigger>
      {{
        regionControl.value
          ? (regionControl.value | regionName: countryControl.value : true)
          : ""
      }}
    </gax-select-trigger>
    @for (option of filteredRegions | async; track option) {
      <gax-option
        [value]="option.code"
        [disabled]="disabledCountries?.includes(option.code) || false"
        >{{ option.code | regionName: countryControl.value : true }}
      </gax-option>
    }
    @if (regionControl.hasError("required")) {
      <gax-error>
        {{ regionLabel }} required for
        {{ countryControl.value | countryName }}
      </gax-error>
    }
  </gax-select-form-field-deprecated-use-mat-select>
}
